import React, { useContext, useEffect, useState } from "react";
import ReservacionRow from "./ReservacionRow";
import { ReservationsContext } from "../../context/ReservationsContext";
import Pagination from "../global/Pagination";

const PAGE_SIZE = 50;

const ReservationsTable = ({ customer_id }) => {
  const [page, setPage] = useState(1);
  const { total, reservations, getClassReservations, filter } =
    useContext(ReservationsContext);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, customer_id, filter]);

  const getData = () => {
    getClassReservations({
      page,
      filter,
      customer_id,
    });
  };

  const renderReservaciones = () => {
    if (!Array.isArray(reservations)) return <div className="spinner-border" />;
    return (
      <table className="table border">
        <thead className="bg-light border bold small">
          <tr>
            <td>#ID</td>
            <td>Clase</td>
            <td>Coach</td>
            <td>Fecha</td>
            <td>Reservada en</td>
            <td>Status</td>
            <td className="text-center">Acciones</td>
          </tr>
        </thead>
        <tbody>
          {reservations.map((reservation) => (
            <ReservacionRow
              key={reservation.class_reservation_id}
              reservation={reservation}
              deleteCallback={getData}
            />
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div>
      <div className="table-responsive">{renderReservaciones()}</div>
      {total > PAGE_SIZE && (
        <Pagination
          totalItems={total}
          currentPage={page}
          onPageChange={setPage}
          itemsPerPage={PAGE_SIZE}
        />
      )}
    </div>
  );
};

export default ReservationsTable;
